import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';


import API from '../services/api';

// ── Single record component ───────────────────────────
function StatusRecord({ record, officers }) {
  const openOfficer = officers[record.opening_officer_id];
  const inspect1    = officers[record.inspection_officer_1_id];
  const inspect2    = officers[record.inspection_officer_2_id];

  const partsToPurchase = record.repair_comment
    ? record.repair_comment.split('\n').map(l => l.trim()).filter(Boolean)
    : [];

  const chk = (val) => val ? '√' : ' ';

  return (
    <div>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: 5, fontWeight: 'bold' }}>
        <h3 style={{ margin: '3px 0', fontSize: '12pt' }}>
          පරිගණක යන්ත්‍ර අලුත්වැඩියා කිරීමේ තත්ත්ව වාර්තාව
        </h3>
      </div>
      <div style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: 8, fontSize: '9pt' }}>
        (එක් උපකරණයක් සඳහා එක් පෝරමයක් පිරවිය යුතු ය.)
      </div>

      <p>{record.school_assigned_number}</p>

      <table>
        <tbody>
          <tr>
            <td width="5%">1.</td>
            <td width="28%">පාසලේ නම ලිපිනය හා දුරකථන අංකය -</td>
            <td colSpan="2">
              {record.school_number}
              {record.phone_number ? ` - ${record.phone_number}` : ''}
              {record.school_address ? ` - ${record.school_address}` : ''}
            </td>
          </tr>
          <tr>
            <td>2.</td>
            <td rowSpan="4">පරිගණක හා සම්බන්ධව අලුත්වැඩියා කිරීමට ඇත්තේ (√)</td>
            <td>1. System Unit</td>
            <td>[{chk(record.type === 'system_unit')}]</td>
          </tr>
          <tr><td></td><td>2. Mother Board</td><td>[{chk(record.type === 'motherboard')}]</td></tr>
          <tr><td></td><td>3. Monitor</td><td>[{chk(record.type === 'monitor')}]</td></tr>
          <tr>
            <td></td>
            <td>4. වෙනත් (සඳහන් කරන්න.)</td>
            <td>[{chk(record.type === 'other')}] {record.type === 'other' ? record.device_name : ''}</td>
          </tr>
          <tr>
            <td>3.</td>
            <td>පරිගණක වර්ගය හා අනුක්‍රමික අංකය -</td>
            <td colSpan="2">
              {record.type === 'system_unit'
                ? `${record.device_name || ''}${record.device_name && record.serial_number ? ' - ' : ''}${record.serial_number || ''}`
                : ''}
            </td>
          </tr>
          <tr>
            <td>4.</td>
            <td>මොනිටරයේ වර්ගය (Model) හා අනුක්‍රමික අංකය -</td>
            <td colSpan="2">
              {record.type === 'monitor'
                ? `${record.device_name || ''}${record.device_name && record.serial_number ? ' - ' : ''}${record.serial_number || ''}`
                : ''}
            </td>
          </tr>
          <tr>
            <td>5.</td>
            <td>මවු පුවරු වර්ගය හා අනුක්‍රමික අංකය -</td>
            <td colSpan="2">
              {record.type === 'system_unit'
                ? `${record.motherboard_type || ''}${record.motherboard_type && record.motherboard_serial ? ' - ' : ''}${record.motherboard_serial || ''}`
                : ''}
            </td>
          </tr>
          <tr>
            <td>6.</td>
            <td>වෙනත් (සඳහන් කරන්න.)</td>
            <td colSpan="2">
              {record.type === 'other'
                ? `${record.device_description || ''}${record.device_description && record.serial_number ? ' - ' : ''}${record.serial_number || ''}`
                : ''}
            </td>
          </tr>
          <tr><td>7.</td><td>අනාවරණය කරගත් දෝෂ</td><td colSpan="2"></td></tr>
          <tr><td></td><td>a.</td><td colSpan="2">{record.identified_issues || ''}</td></tr>
          <tr><td></td><td>b.</td><td colSpan="2"></td></tr>
          <tr><td></td><td>c.</td><td colSpan="2"></td></tr>
          <tr><td>8.</td><td colSpan="3">අවශ්‍ය අමතර කොටස්</td></tr>
          <tr><td></td><td>නම</td><td>වර්ගය</td><td>විස්තරය</td></tr>
          {['a','b','c','d'].map(l => (
            <tr key={l}><td></td><td>{l}.</td><td></td><td></td></tr>
          ))}
        </tbody>
      </table>

      <div style={{ marginTop: 5 }}>
        <p>9. අවසන් වාර්තාව ( පහත සඳහන් 1, 2, 3න් අනවශ්‍ය කොටස් කපා හරින්න.)</p>
        <p>1. මෙම උපකරණය සම්පූර්ණ වශයෙන් යථා තත්ත්වයට පත් කර ඇත.[{record.status === 'fixed' ? '√' : ' '}]</p>
        <p>2. මෙම උපකරණය/ පහත සඳහන් උපාංගය මිල දී ගෙන සවි කිරීමෙන් යථා තත්ත්වයට පත් කර ගත හැකි ය.[{record.status === 'needs_parts' ? '√' : ' '}]</p>
        <div style={{ marginLeft: 10, marginBottom: 5 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td style={{ width: '50%', border: '1px solid black', padding: 2 }}>මිල දී ගත යුතු භාණ්ඩයේ නම</td>
                <td style={{ width: '50%', border: '1px solid black', padding: 2 }}>අදාළ පිරිවිතර</td>
              </tr>
              {partsToPurchase.length > 0 ? (
                partsToPurchase.map((part, i) => {
                  const [name, spec] = part.includes('|') ? part.split('|') : [part, ''];
                  return (
                    <tr key={i}>
                      <td style={{ border: '1px solid black', padding: 2 }}>{String.fromCharCode(65+i)}. {name}</td>
                      <td style={{ border: '1px solid black', padding: 2 }}>{spec}</td>
                    </tr>
                  );
                })
              ) : (
                ['A','B','C'].map(l => (
                  <tr key={l}>
                    <td style={{ border: '1px solid black', padding: 2 }}>{l}.</td>
                    <td style={{ border: '1px solid black', padding: 2 }}></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <p>3. මෙම උපකරණය භාවිතා කළ නොහැක.[{record.status === 'unusable' ? '√' : ' '}]</p>
      </div>

      <div style={{ marginTop: 10 }}>
        <p>උපකරණය පරීක්ෂා කර බැලුවේ,</p>
        <table>
          <tbody>
            <tr><th>නම</th><th>රාජකාරි ලිපිනය</th><th>අත්සන</th></tr>
            {openOfficer && <tr><td>A. {openOfficer.nama}</td><td>{openOfficer.lipinaya}</td><td style={{ width: 100 }}></td></tr>}
            {inspect1    && <tr><td>B. {inspect1.nama}</td><td>{inspect1.lipinaya}</td><td></td></tr>}
            {inspect2    && <tr><td>C. {inspect2.nama}</td><td>{inspect2.lipinaya}</td><td></td></tr>}
          </tbody>
        </table>
      </div>

      <div style={{ margin: '10px 0', lineHeight: 1.3, fontSize: '9pt' }}>
  <p>
    {record.status === 'fixed' &&
      'ඉහත තොරතුරු සත්‍ය හා නිවැරදි වන අතර මෙම උපකරණය සම්පූර්ණ වශයෙන් යථා තත්ත්වයට පත් කර ඇති බව ප්‍රකාශ කරමි.'}
    {record.status === 'needs_parts' &&
      'ඉහත තොරතුරු සත්‍ය හා නිවැරදි වන අතර මෙම උපකරණය යථා තත්ත්වයට පත් කර ගැනීම සඳහා ඉහත සඳහන් උපාංග මිලදී ගත යුතු බව නිර්දේශ කරමි.'}
    {record.status === 'unusable' &&
      'ඉහත තොරතුරු සත්‍ය හා නිවැරදි වන අතර මෙම උපකරණය භාවිතයෙන් ඉවත් කළ යුතු බව නිර්දේශ කරමි.'}
  </p>
</div>
      <div style={{ marginTop: 15 }}>
        <div style={{ marginTop: 20, borderTop: '1px solid black', width: 200 }}></div>
        <p style={{ fontSize: '9pt', marginTop: 3 }}>
          නියෝජ්‍ය /සහකාර අධ්‍යාපන අධ්‍යක්ෂ (තොරතුරු හා සන්නිවේදන තාක්ෂණ),<br/>
          අධ්‍යාපන අමාත්‍යාංශය/පළාත් අධ්‍යාපන දෙපාර්තමේන්තුව/කලාප අධ්‍යාපන කාර්යාලය
        </p>
      </div>
    </div>
  );
}

// ── Main page ─────────────────────────────────────────
export default function PrintStatusReportPage() {
  const [searchParams] = useSearchParams();
  const schoolName     = searchParams.get('school');
  const date           = searchParams.get('date');

  const [records,  setRecords]  = useState([]);
  const [officers, setOfficers] = useState({});
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    API.get('/maintenance').then(async res => {
      let data = res.data;
      if (schoolName) data = data.filter(r => r.school_number === schoolName);
      if (date)       data = data.filter(r => r.opened_date?.slice(0,10) === date);
      setRecords(data);

      const o   = {};
      const ids = [...new Set(data.flatMap(r => [
        r.opening_officer_id, r.inspection_officer_1_id, r.inspection_officer_2_id,
      ]).filter(Boolean))];
      await Promise.all(ids.map(async oid => {
        try { const r2 = await API.get(`/employees/${oid}`); o[oid] = r2.data; } catch {}
      }));
      setOfficers(o);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [schoolName, date]);

  useEffect(() => {
    if (!loading && records.length > 0) setTimeout(() => window.print(), 700);
  }, [loading, records]);

  if (loading) return <div style={{ textAlign: 'center', padding: 40 }}>පූරණය වෙමින්...</div>;
  if (!records.length) return (
    <div style={{ textAlign: 'center', padding: 40 }}>
      <p>වාර්තා නොමැත — පාසල: {schoolName} | දිනය: {date}</p>
      <button onClick={() => window.history.back()}
        style={{ marginTop: 20, background: '#ef4444', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
        ← ආපසු
      </button>
    </div>
  );

  return (
    <>
      <style>{`
        @page { size: A4; margin: 1cm 1.5cm; }
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: "Iskoola Pota", Arial, sans-serif; line-height: 1.2; font-size: 10pt; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 5px; }
        td, th { border: 1px solid black; padding: 3px; vertical-align: top; font-size: 9pt; }
        p { margin: 3px 0; }
        .page-break { page-break-before: always; }
        .no-print { display: none; }
        @media screen {
          .no-print { display: flex; gap: 8px; padding: 10px; background: #f3f4f6; }
          body { padding: 10px; }
          .record-wrapper { border: 1px dashed #ccc; padding: 10px; margin-bottom: 20px; }
        }
      `}</style>

      {/* Screen buttons */}
      <div className="no-print">
        <button onClick={() => window.history.back()}
          style={{ background: '#ef4444', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
          ← ආපසු
        </button>
        <button onClick={() => window.print()}
          style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
          🖨️ සියල්ල මුද්‍රණය ({records.length} වාර්තා)
        </button>
        <span style={{ padding: '8px', fontSize: '13px', color: '#555' }}>
          📋 {schoolName} | {date} | වාර්තා {records.length}ක්
        </span>
      </div>

      {/* All records — each on its own page */}
      {records.map((record, index) => (
        <div
          key={record.id}
          className={`record-wrapper ${index > 0 ? 'page-break' : ''}`}
        >
          <StatusRecord record={record} officers={officers} />
        </div>
      ))}
    </>
  );
}